import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import GenericMap from "@/assets/Mapsicle Map.webp";
import CollapsibleDescription from "./CollapsibleDescription";
import AmbassadorsList from "./AmbassadorsList";
import AmbassadorsModal from "./AmbassadorsModal";

export default function CardEmbajadores({ evento }) {
  // console.log("Evento en CardEmbajadores:", evento);
  const [showAmbassadorsModal, setShowAmbassadorsModal] = useState(false);

  return (
    <div className="relative bg-aw-bluedark-95 rounded-2xl sm:p-6 flex flex-col items-center justify-start w-full min-h-fit xl:min-h-[80dvh] space-y-4">
      <div className="flex flex-col items-center justify-between w-full">
        {evento?.useAmbassador == 2 && (
          <>
            <div className="text-white font-bold text-lg mb-2">
              Staff Oficial de Embajadores
            </div>

            {/* Lista de embajadores */}
            {evento?.embajadores && evento.embajadores.length > 0 && (
              <div className="w-full mb-4 flex flex-col items-center justify-center">
                <AmbassadorsList ambassadors={evento.embajadores} />

                {/* Botón para ver todos si hay más de 2 embajadores */}
                {evento.totalEmbajadores > 2 && (
                  <button
                    onClick={() => setShowAmbassadorsModal(true)}
                    className="mt-4 text-xs w-fit mx-auto bg-aw-green/20 hover:bg-aw-green/30 text-aw-green font-semibold py-2 px-4 rounded-lg transition-colors duration-200 border border-aw-green/40"
                  >
                    Ver todos los embajadores
                  </button>
                )}
              </div>
            )}
          </>
        )}

        <div className="text-center font-semibold text-white text-lg mb-2">
          Descripción
        </div>

        {/* Descripción colapsable */}
        <CollapsibleDescription text={evento.descripcion} />
      </div>

      {/* Ubicación */}
      <div>
        <div className="relative w-full h-28 mb-2">
          <div className="absolute w-full h-full bg-aw-bluedark/65 flex flex-col gap-y-2 items-center justify-center px-4">
            {evento?.direccion && (
              <span className="text-xs text-white line-clamp-1">
                Ubicación:{" "}
                <span className="font-medium">
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className="text-red-500"
                  />{" "}
                  {evento.direccion || "Por definir"}
                </span>
              </span>
            )}
            {/* Botones de mapa */}
            {evento?.ubicacion == "" || evento?.ubicacion == null ? (
              <></>
            ) : (
              <div className="flex">
                <a
                  href={`${evento.ubicacion} `}
                  target="_blank"
                  className="bg-aw-bluedark text-white px-3 py-1 rounded-full border border-aw-green hover:bg-aw-green hover:text-aw-bluedark text-xs duration-300"
                >
                  Google Maps
                </a>
              </div>
            )}
          </div>
          <img
            src={GenericMap}
            alt="Mapa de ubicación"
            className="w-full h-full object-cover rounded-lg"
          />
        </div>
        {/* Palabras clave */}
        {/* <div className="w-full mt-6">
            <h4 className="font-medium text-base text-white text-left">
              Palabra Clave
            </h4>
            <div className="flex flex-wrap gap-2 mt-2">
              {evento.palabrasClave.map((pal, i) => (
                <span
                  key={i}
                  className={`px-2 py-1 rounded-full text-xs font-semibold ${
                    i === 0
                      ? "bg-aw-green text-aw-bluedark"
                      : "bg-aw-bluedark text-white border border-gratext-gray-400"
                  }`}
                >
                  {pal}
                </span>
              ))}
            </div>
          </div> */}
      </div>

      {/* Modal de embajadores */}
      <AmbassadorsModal
        isOpen={showAmbassadorsModal}
        onClose={() => setShowAmbassadorsModal(false)}
        uidEvento={evento?.id}
      />
    </div>
  );
}
